<!--
IMPORTANT:
This file is used only in the vue3 application
Any changes made here should be do in the vue2 file also
Any clarifications contact Divya

Vue2File :wwwroot\js\components\MegaMenu\MenuImageTiles\MenuImageTiles.vue
-->
<template>
  <div v-if="tilesData?.length" :class="['tiles-container', layoutClass]">
    <a v-for="(tile, index) in tilesData" :key="index" :href="tile.url" class="tile-item" @click="onTileClick(tile)">
      <div v-if="tile.captionText" class="tile-title">{{ tile.captionText }}</div>
      <v-lazy-image
        v-if="tile.placeHolderImage"
        :src="tile.tileImage"
        :src-placeholder="tile.placeHolderImage"
        class="img-fluid"
        :alt="tile.altText || 'tile image'"
      />
      <img
        v-else src="https://service.secureoffersites.com/images/GetLibraryImage?fileNameOrId=0"
        class="photo-not-available img-fluid" alt="tile img"
      />
    </a>
  </div>
</template>
<script>
import axios from 'axios';
import VLazyImage from "v-lazy-image"; //won't support

//cross check the path

import ShiftDigitalService from '../../../Events/ShiftDigital/ShiftDigitalService';
import ShiftDigitalContainer from '../../../Events/ShiftDigital/ShiftDigitalContainer';


export default {
  components: {
    VLazyImage
  },
  props: {
    menuSectionId: {
      required: true,
      type: Number
    }
  },
  data(){
    return{
      shiftDigital: '',
      tilesData: [],
      isMobile: !!window?.ismobile
    }
  },
  computed: {
    layoutClass() {
      const count = this.tilesData.length;
      if (count === 1) return 'layout-1';
      if (count === 2) return 'layout-2';
      if (count === 3) return 'layout-3';
      if (count === 4) return 'layout-4';
      return '';
    },
  },
  mounted() {
    this.shiftDigital = ShiftDigitalContainer.getShiftDigitalObject();
    this.getTilesData();
  },
  methods:{
    onTileClick(tile) {
      if (tile.url?.toLowerCase().includes('scheduleservice') && this.shiftDigital) {
        ShiftDigitalService.scheduleServiceClick(this.shiftDigital);
      }
    },
    async getTilesData() {
      try{
         const response = await axios.get(
           `${window.ApiBaseUrl}/Menu/getmenusectiondetails/${this.menuSectionId}`
          );
        if(response?.data) {
          this.tilesData = (response.data.menuTileImages || []).map(tile => ({
            ...tile,
            placeHolderImage: this.getImageUrl(tile, 'webp', 6),
            tileImage: this.getImageUrl(tile, 'webp', 95),
          }));
        }else {
          console.log("No data returned from the API.");
        }
      }
      catch(error){
        console.log(error);
      }
      finally{
        console.log("finally block");
      }
    },
    getImageUrl(tileItem, type, quality) {
      const imageURL = tileItem?.[this.isMobile ? "mobileImageUrl" : "imageUrl"];
      return imageURL ? `${imageURL}&type=${type}&quality=${quality}` : "";
    },
  }
}
</script>

<style scoped>
  .tiles-container {
    display: grid;
    gap: 20px;
    width: 100%;
    margin: 0 auto;
    grid-template-columns: repeat(2, 1fr);
    grid-auto-rows: 1fr;
  }
  .tiles-container:has(.tile-item:nth-child(3):last-child) .tile-item:last-child {
    grid-column: -1/1;
  }
  .tiles-container:has(.tile-item:nth-child(2):last-child), .tiles-container:has(.tile-item:first-child:last-child) {
    grid-template-columns: 1fr;
  }
  .tile-item {
    border-radius: 20px;
    overflow: hidden;
    position: relative;
  }
  .tile-item img {
    image-rendering: auto;
    height: 100%;
    width: 100%;
    object-fit: cover;
    transition: transform 0.5s ease, filter 0.5s ease;
  }
  .tile-item img:hover {
    transform: scale(1.1);
  }
  .tile-title {
    position: absolute;
    top: 20px;
    text-align: center;
    z-index: 2;
    width: 100%;
    color: #fff;
    font-size: 24px;
    font-weight: bold;
  }
  .photo-not-available {
    object-fit: contain !important;
  }
  @media(max-width: 1600px) {
    .layout-1 {
      grid-template-columns: auto !important;
    }

    .layout-2 {
      grid-template-columns: auto !important;
    }

    .layout-3 {
      grid-template-columns: repeat(2, auto);
      grid-template-rows: auto auto;
    }

    .layout-3 .tile-item:nth-child(3) {
      grid-column: 1 / -1;
    }

    .layout-4 {
      grid-template-columns: repeat(2, auto);
      justify-content: center;
      gap: 20px;
    }
    .tiles-container {
      justify-content: center;
    }
    .tile-item {
      display: flex;
    }
  }
</style>
